import { Vector3 } from 'three';

export function getBoxVertices(min: Vector3, max: Vector3) {
  const vertices: number[] = [
    min.x,
    min.y,
    min.z,
    max.x,
    min.y,
    min.z,
    max.x,
    min.y,
    min.z,
    max.x,
    max.y,
    min.z,
    max.x,
    max.y,
    min.z,
    min.x,
    max.y,
    min.z,
    min.x,
    max.y,
    min.z,
    min.x,
    min.y,
    min.z,

    min.x,
    min.y,
    max.z,
    max.x,
    min.y,
    max.z,
    max.x,
    min.y,
    max.z,
    max.x,
    max.y,
    max.z,
    max.x,
    max.y,
    max.z,
    min.x,
    max.y,
    max.z,
    min.x,
    max.y,
    max.z,
    min.x,
    min.y,
    max.z,

    min.x,
    min.y,
    min.z,
    min.x,
    min.y,
    max.z,
    max.x,
    min.y,
    min.z,
    max.x,
    min.y,
    max.z,
    max.x,
    max.y,
    min.z,
    max.x,
    max.y,
    max.z,
    min.x,
    max.y,
    min.z,
    min.x,
    max.y,
    max.z
  ];

  return vertices;
}
